import styled from 'styled-components';

import { colors } from 'global/colors';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 280px;
`;

export const SearchContainer = styled.div`
  display: flex;
  background: ${colors.white};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  padding: 7px 10px;
  border-radius: 5px;
  user-select: none;

  @media (max-width: 768px) {
    max-width: none;
  }

  :focus-within {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
`;

export const SearchInput = styled.input`
  font-size: 16px;
  border: none;
  background: transparent;
  outline: none;
  color: ${colors.darkGray};
  flex: 1;
`;

export const SearchIcon = styled.div`
  :after {
    content: '\f002';
    font-family: FontAwesome;
    color: ${colors.darkGray};
    margin-left: 5px;
  }
`;

export const ClearIcon = styled.div`
  :after {
    content: '\f00d';
    font-family: FontAwesome;
    color: ${colors.darkGray};
    cursor: pointer;
  }
`;

export const ItemsContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 3;
  background: ${colors.white};
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
`;

export const Item = styled.div`
  background: ${colors.white};
  padding: 7px 10px;
  user-select: none;
  cursor: pointer;

  :hover {
    background: #efefef;
  }
`;

export const Hr = styled.hr`
  margin: 0;
  width: 95%;
  margin-left: 2.5%;
`;
